import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.insertAdjacentHTML('beforeend', '<div class="w-full absolute opacity-85 bottom-0 left-0 h-1 bg-white progress-fade rounded-bl-lg"></div>');
    this.$progressFade = this.element.querySelector('.progress-fade');
    this.width = this.$progressFade.offsetWidth;
    this.delay = 2000;
    this.rate = this.width / this.delay;

    this.count = 1;
    this.interval = setInterval(() => { this.fadeProgressOut() }, 1);

    this.element.addEventListener('mouseenter', () => {
      clearInterval(this.interval);
    });

    this.element.addEventListener('mouseleave', () => {
      this.interval = setInterval(() => { this.fadeProgressOut() }, 1);
    });
  }

  fadeProgressOut() {
    this.width -= this.rate;
    this.$progressFade.style.width = `${this.width}px`;
    if (this.count++ == this.delay) {
      clearInterval(this.interval);
      this.element.remove();
    }
  }

  disconnect() {
    clearInterval(this.interval);
  }
};